/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ReportOrganisationCreateErrorsMutationVariables = Types.Exact<{
  uuid: Types.Scalars['String'];
  errorDetails: Array<Types.OrganisationCreateErrorInput> | Types.OrganisationCreateErrorInput;
}>;


export type ReportOrganisationCreateErrorsMutation = { __typename: 'Mutation', reportOrganisationCreateErrors: { __typename: 'ErrorDetailsEmailStatus', status: boolean } };


export const ReportOrganisationCreateErrorsDocument = gql`
    mutation ReportOrganisationCreateErrors($uuid: String!, $errorDetails: [OrganisationCreateErrorInput!]!) {
  reportOrganisationCreateErrors(uuid: $uuid, errorDetails: $errorDetails) {
    status
  }
}
    `;
export type ReportOrganisationCreateErrorsMutationFn = ApolloReactCommon.MutationFunction<ReportOrganisationCreateErrorsMutation, ReportOrganisationCreateErrorsMutationVariables>;

/**
 * __useReportOrganisationCreateErrorsMutation__
 *
 * To run a mutation, you first call `useReportOrganisationCreateErrorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportOrganisationCreateErrorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportOrganisationCreateErrorsMutation, { data, loading, error }] = useReportOrganisationCreateErrorsMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      errorDetails: // value for 'errorDetails'
 *   },
 * });
 */
export function useReportOrganisationCreateErrorsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReportOrganisationCreateErrorsMutation, ReportOrganisationCreateErrorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReportOrganisationCreateErrorsMutation, ReportOrganisationCreateErrorsMutationVariables>(ReportOrganisationCreateErrorsDocument, options);
      }
export type ReportOrganisationCreateErrorsMutationHookResult = ReturnType<typeof useReportOrganisationCreateErrorsMutation>;
export type ReportOrganisationCreateErrorsMutationResult = ApolloReactCommon.MutationResult<ReportOrganisationCreateErrorsMutation>;
export type ReportOrganisationCreateErrorsMutationOptions = ApolloReactCommon.BaseMutationOptions<ReportOrganisationCreateErrorsMutation, ReportOrganisationCreateErrorsMutationVariables>;